import api from "./api";

export const listAdminAnnouncements = async (query = {}) => {
  const { data } = await api.get("/admin/v1/announcements", { params: query });
  return data;
};

export const showAdminAnnouncement = async (id) => {
  const { data } = await api.get(`/admin/v1/announcements/${id}`);
  return data;
};

export const createAdminAnnouncement = async (payload) => {
  const { data } = await api.post("/admin/v1/announcements", payload);
  return data;
};

export const updateAdminAnnouncement = async (id, payload) => {
  const { data } = await api.patch(`/admin/v1/announcements/${id}`, payload);
  return data;
};

export const deleteAdminAnnouncement = async (id) => {
  const { data } = await api.delete(`/admin/v1/announcements/${id}`);
  return data;
};

export const uploadAnnouncementMedia = async (id, formData) => {
  const { data } = await api.post(`/admin/v1/announcements/${id}/media`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
};

export const deleteAnnouncementMedia = async (id) => {
  const { data } = await api.delete(`/admin/v1/announcements/${id}/media`);
  return data;
};

export const listAllCompanies = async () => {
  const { data } = await api.get("/admin/v1/announcements/companies");
  return data;
};
